<template>
    <div class="flex flex-col" :class="{ 'mt-6': boundary === 'zip' }">
      <div class="flex items-center gap-x-2">
        <label class="block text-sm/6 mb-0 font-medium text-gray-900">Selected Points of Interests</label>
        <template v-if="selectedPOIs.length > 0">
          <button
            type="button"
            @click="$emit('openFilterModal', 'poi')"
            class="underline text-blue-600 text-xs font-semibold"
          >
            Manage
          </button>
          <button
            type="button"
            @click="$emit('clearAllPOIs')"
            class="underline text-red-600 text-xs font-semibold"
          >
            Clear
          </button>
        </template>
      </div>
  
      <div class="p-5 border-2 border-dashed border-gray-200 text-center">
        <template v-if="selectedPOIs.length > 0">
          <div class="mb-3 flex flex-wrap gap-2">
            <div
              v-for="poi in selectedPOIDetails"
              :key="poi.value"
              class="flex items-center gap-x-1 px-3 py-1.5 text-sm font-medium bg-teal-600 text-white rounded-lg"
            >
              <span>{{ poi.label }}</span>
              <button
                type="button"
                @click="$emit('removePOI', poi.value)"
                class="ml-1 text-white hover:text-gray-200"
              >
                <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  viewBox="0 0 24 24">
                  <path d="M18 6 6 18"/>
                  <path d="m6 6 12 12"/>
                </svg>
              </button>
            </div>
          </div>
        </template>
  
        <template v-else>
          <button
            type="button"
            @click="$emit('openFilterModal', 'poi')"
            class="text-blue-500 font-semibold text-sm hover:underline hover:text-blue-400"
            title="Add POI Filters"
          >
            <span>Add POI Filter(s)</span>
          </button>
        </template>
      </div>
    </div>
  </template>
  
  <script>

  export default {
    name: 'CreSiteIqPOISelector',
    props: {
      boundary: String,
      selectedPOIs: Array,
      availablePOITypes: Array
    },
    computed: {
      selectedPOIDetails() {
        return this.availablePOITypes.filter(poi => this.selectedPOIs.includes(poi.value));
      }
    }
  };
  </script>
  